export interface GridTextWithIconModel {
  iconClass: string;
  iconPosition?: 'prefix' | 'suffix';
  displayIcon: boolean;
  tooltipMessage: string;
}
